import { useEffect } from 'react';
import {
    useBrandId,
    useDeviceTypeId,
    useIsHybrid,
    useIsMobile,
    useOsName,
    useOsVersion,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useCustomerId,
    useRegulationTypeId,
} from '~SpectateStore/hooks/userHooks';
import { setCustomAttribute } from '~spa/Utils/Newrelic';

export const useNewRelic = () => {
    const brandId = useBrandId();
    const customerId = useCustomerId();
    const deviceTypeId = useDeviceTypeId();
    const isHybrid = useIsHybrid();
    const isMobile = useIsMobile();
    const osName = useOsName();
    const osVersion = useOsVersion();
    const regulationTypeId = useRegulationTypeId();

    const nrParams = {
        brandId,
        customerId: customerId || null,
        deviceTypeId,
        isHybrid: Number(isHybrid),
        isMobile: Number(isMobile),
        osName,
        osVersion,
        regulationTypeId,
    };

    useEffect(() => {
        setCustomAttribute(nrParams);
    }, [customerId, regulationTypeId]);
};
